import http from './http'
import qs from 'qs'

const tokenBasic = btoa('web_organization_admin:mobile')
const tokenBasicAdmin = btoa('web_global_admin:mobile')

function authorize (username, password, organizationId) {
  return http({
    method: 'POST',
    url: '/oauth/token',
    data: qs.stringify({
      grant_type: 'password',
      username,
      password,
      organizationId
    }),
    headers: {
      'Authorization': 'Basic ' + tokenBasic,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
    .then(response => {
      setSession(response.data)
      return response
    })
}

function authorizeAdmin (username, password) {
  return http({
    method: 'POST',
    url: '/oauth/token',
    data: qs.stringify({
      grant_type: 'password',
      username,
      password
    }),
    headers: {
      'Authorization': 'Basic ' + tokenBasicAdmin,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
    .then(response => {
      setSession(response.data)
      return response
    })
}

function refreshAccessToken () {
  return http({
    method: 'POST',
    url: '/oauth/token',
    data: qs.stringify({
      grant_type: 'refresh_token',
      refresh_token: getRefreshToken()
    }),
    headers: {
      'Authorization': 'Basic ' + tokenBasic,
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
    .then(response => {
      setSession(response.data)
      return response.data.access_token
    })
    .catch(() => {
      logout()
      window.location.reload()
    })
}

function revokeAccessToken () {
  return http({
    method: 'POST',
    url: '/tokens/revokeAccessToken/' + getAccessToken()
  })
}

function revokeRefreshToken () {
  return http({
    method: 'POST',
    url: '/tokens/revokeRefreshToken/' + getRefreshToken()
  })
}

function setSession (data) {
  localStorage.setItem('access_token', data.access_token)
  localStorage.setItem('refresh_token', data.refresh_token)
}

function getAccessToken () {
  return localStorage.getItem('access_token')
}

function getRefreshToken () {
  return localStorage.getItem('refresh_token')
}

function logout () {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
}

function isAuthenticated () {
  return getAccessToken() && getRefreshToken()
}

export {
  authorize,
  authorizeAdmin,
  refreshAccessToken,
  revokeAccessToken,
  revokeRefreshToken,
  getAccessToken,
  getRefreshToken,
  logout,
  isAuthenticated
}



// WEBPACK FOOTER //
// ./src/services/api/auth.js